import commonApi from './CommonApi.js';

export default {
	getForDropdown: async (parameter) => {
		return await commonApi().get('/v1/notificationStatuses/getForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	}
}